/* BBRU hero slideshow — vanilla, section-scoped, accessible.
   Ported from the homepage prototype with: configurable interval, autoplay
   toggle, pause-on-hover, pause-when-tab-hidden, swipe, keyboard, and
   prefers-reduced-motion (no autoplay, instant change). 2026-07-03. */
(function () {
  function initHero(hero) {
    if (hero.dataset.bhInit === '1') return;
    hero.dataset.bhInit = '1';

    var track = hero.querySelector('[data-bh-slides]');
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-bh-slide]'));
    var dotsWrap = hero.querySelector('[data-bh-dots]');
    var prevBtn = hero.querySelector('[data-bh-prev]');
    var nextBtn = hero.querySelector('[data-bh-next]');
    if (!slides.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = hero.dataset.bhAutoplay === 'true' && !reduce;
    var interval = parseInt(hero.dataset.bhInterval, 10) || 6000;
    var count = slides.length;
    var i = 0, timer = null;

    // Build dots
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (_, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Go to slide ' + (n + 1));
        if (n === 0) b.classList.add('is-active');
        b.addEventListener('click', function () { go(n, true); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function go(n, manual) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + count) % count;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
      if (manual) restart();
    }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }
    function start() { if (autoplay && count > 1 && !timer) timer = setInterval(next, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });

    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { next(); restart(); }
      if (e.key === 'ArrowLeft') { prev(); restart(); }
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // touch swipe
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { (dx < 0 ? next() : prev()); restart(); }
      x0 = null;
    }, { passive: true });

    start();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-bh-hero]')).forEach(initHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Re-init when a section is added/re-rendered in the theme editor
  document.addEventListener('shopify:section:load', initAll);
})();
